// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1SuLp","content":"styles_content__1tFp5","checkbox":"styles_checkbox__1lFnR","checkboxLabel":"styles_checkboxLabel__20i2t"};